// extracted by mini-css-extract-plugin
export default {"root":"styles_root__VD-DY","unavailable":"styles_unavailable__paeO1"};